import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router-dom';
import SunLifeInitiateProposalPageStore, {
  SunLifeInitiateProposalPageStoreContext,
  useSunLifeInitiateProposalPageStore,
} from 'store/pages/initiate-quote/sunLife/pageStore';
import SunLifeInitiateProposalForm from 'components/initiate-quote/SunLife';
import InitiateProposalPageLayout from 'components/common/initiate-proposal/InitiateProposalPageLayout';
import QuoteExperienceStep from 'components/common/initiate-proposal/QuoteExperienceStep';
import FavoriteQuoteStep from 'components/common/initiate-proposal/FavoriteQuoteStep';

const PageContent: React.FC = observer(() => {
  const {
    initiateQuoteFlowDelegate,
    bulletTabsDelegate,
    basicInfoStepController,
    proposalExperienceStepController,
    favoriteProposalStepController,
    proposalExperience,
    getInitialData,
  } = useSunLifeInitiateProposalPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <InitiateProposalPageLayout
      initiateQuoteFlowDelegate={initiateQuoteFlowDelegate}
      bulletTabsDelegate={bulletTabsDelegate}
      tabs={[
        <SunLifeInitiateProposalForm key="0" basicInfoStepController={basicInfoStepController} />,
        <QuoteExperienceStep
          key="1"
          formController={proposalExperienceStepController.form}
          experiences={proposalExperienceStepController.experiences}
          experienceDisabledReasons={proposalExperienceStepController.experienceDisabledReasons}
          experienceAccessLimitations={proposalExperienceStepController.experienceAccessLimitations}
          renewalActionsDelegate={proposalExperienceStepController.renewalActionsDelegate}
        />,
        proposalExperience === 'FAVORITE' && (
          <FavoriteQuoteStep key="2" favoriteProposalStepController={favoriteProposalStepController} />
        ),
      ].filter(Boolean)}
    />
  );
});

const SunLifeInitiateProposalPage: React.FC = () => {
  const { groupId } = useParams<{ groupId: string }>();

  const pageStore = useMemo(() => new SunLifeInitiateProposalPageStore({ groupId }), [groupId]);

  return (
    <SunLifeInitiateProposalPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </SunLifeInitiateProposalPageStoreContext.Provider>
  );
};

export default SunLifeInitiateProposalPage;
